import { US as clinicSharedUS } from "@clinic/shared/locales";
import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";

import { account } from "./account";
import { address } from "./address";
import { backOrders } from "./backOrders";
import { brands } from "./brands";
import { cart } from "./cart";
import { catalog } from "./catalog";
import { common } from "./common";
import { educationalResources } from "./educationalResources";
import { footer } from "./footer";
import { harmonizedAccount } from "./harmonizedAccount";
import { header } from "./header";
import { homepage } from "./homepage";
import { infoPillars } from "./infoPillars";
import { newsletter } from "./newsletter";
import { onboarding } from "./onboarding";
import { orders } from "./orders";
import { privacyPolicy } from "./privacyPolicy";
import { productDetails } from "./productDetails";
import { qualityProgram } from "./qualityProgram";
import { quickOrder } from "./quickOrder";
import { rso } from "./rso";
import { termsOfSales } from "./termOfSales";
import { updateMigrationPassword } from "./updateMigrationPassword";
import { upgrade } from "./upgrade";
import { welcome } from "./welcome";
import { wholesalePolicies } from "./wholesalePolicies";

const US = mergeSharedTranslations({
  ...clinicSharedUS,
  footer,
  header,
  homepage,
  infoPillars,
  upgrade,
  newsletter,
  productDetails,
  qualityProgram,
  catalog,
  common,
  educationalResources,
  account,
  brands,
  cart,
  onboarding,
  orders,
  backOrders,
  address,
  welcome,
  wholesalePolicies,
  quickOrder,
  rso,
  harmonizedAccount,
  updateMigrationPassword,
  privacyPolicy,
  termsOfSales,
});

export { US };
